import React, { useState } from 'react'
import { useEffect } from 'react';
import { API_BASE } from '../api';

function ApplicationForm() {
  // useEffect(() => {
  //   const fileInput = document.getElementById("cvUpload");
  //   const fileName = document.getElementById("fileName");

  //   if (fileInput && fileName) {
  //     fileInput.addEventListener("change", () => {
  //       fileName.textContent = fileInput.files[0]
  //         ? fileInput.files[0].name
  //         : "No file chosen";
  //     });
  //   }

  //   const form = document.querySelector("form");
  //   if (form) {
  //     form.addEventListener("submit", (e) => {
  //       if (!form.checkValidity()) {
  //         e.preventDefault();
  //         form.reportValidity();
  //       }
  //     });
  //   }
  // }, []);

const [form, setForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    role: '',
    department: '',
    startDate: '',
    linkedin: '',
    salary: '',
    cover: '',
    consent: false,
  });

  const [cv, setCv] = useState(null);
  const [status, setStatus] = useState('idle');
  const [fileName, setFileName] = useState('No file chosen');
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  // const onChange = (e) => {
  //   const { id, name, type, value, checked } = e.target;
  //   const key = id || name;
  //   setForm((prev) => ({
  //     ...prev,
  //     [key]: type === 'checkbox' ? checked : value,
  //   }));
  // };

  // const onCvChange = (e) => {
  //   const f = e.target.files?.[0];
  //   setCv(f || null);
  //   setFileName(f ? f.name : 'No file chosen');
  // };

  const onChange = (e) => {
    const { id, type, value, checked } = e.target;
    setForm(prev => ({ ...prev, [id]: type === 'checkbox' ? checked : value }));
  };

  const onCvChange = (e) => {
    const f = e.target.files?.[0] || null;
    setCv(f);
  };

  const handleReset = () => {
    setForm({
      fullName: '',
      email: '',
      phone: '',
      role: '',
      department: '',
      startDate: '',
      linkedin: '',
      salary: '',
      cover: '',
      consent: false,
    });
    setCv(null);
    setFileName('No file chosen');
    setResult(null);
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  fd.append('fullName', form.fullName);
  fd.append('email', form.email);
  fd.append('phone', form.phone);
  fd.append('role', form.role);
  fd.append('department', form.department || '');
  fd.append('startDate', form.startDate || '');
  fd.append('linkedin', form.linkedin || '');
  fd.append('salary', form.salary || '');
  fd.append('cover', form.cover || '');
  // Always send consent as a string so the server sees it:
  fd.append('consent', String(!!form.consent));
  // IMPORTANT: the file field name must match multer.single('<name>')
  fd.append('cv', cv);  // <-- name must match your multer config

  // Debug: print keys you're actually sending
  for (const [k, v] of fd.entries()) {
    console.log('FD', k, (v instanceof File) ? `File(${v.name})` : v);
  }

  // DO NOT set Content-Type manually; let the browser set the boundary
  const res = await fetch(`${API_BASE}/admin/app-form`, {
    method: 'POST',
    body: fd,
  });

  const data = await res.json().catch(() => ({}));
  console.log('status', res.status, data);
  if (!res.ok) {
    alert(data.message || `Bad request (${res.status})`);
    return;
  }
  alert('Submitted!');
};

  return (
    <div>
      <style>{`
        :root{
          --bg:#f7f9fb; --card:#ffffff; --ink:#0f172a; --muted:#6b7280; --brand:#136f63; --brand-2:#19a974; --ring:rgba(25, 169, 116, .25);
          --radius:16px;
        }
        *{box-sizing:border-box}
        body{margin:0; font-family:ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"; color:var(--ink); background:linear-gradient(180deg, var(--bg), #eef4f4);}    
        .wrap{max-width:860px; margin:48px auto; padding:24px}
        .card{background:var(--card); border-radius:var(--radius); box-shadow:0 10px 30px rgba(2,8,23,.06); overflow:hidden; border:1px solid #e8eef3}
        .head{padding:28px 28px 0}
        .title{font-size:28px; margin:0 0 8px; letter-spacing:.2px}
        .subtitle{margin:0 0 22px; color:var(--muted)}
        .brandbar{height:5px; background:linear-gradient(90deg, var(--brand), var(--brand-2));}

        form{padding:28px; display:grid; gap:18px}
        .grid{display:grid; grid-template-columns:1fr; gap:16px}
        @media(min-width:720px){ .grid{grid-template-columns:1fr 1fr} }
        label{display:block; font-weight:600; margin:0 0 6px}
        .req{color:#ef4444; margin-left:4px}
        input[type="text"], input[type="email"], input[type="tel"], input[type="url"], input[type="number"], input[type="date"], select, textarea{
          width:100%; padding:12px 14px; border:1px solid #d9e1ea; border-radius:12px; background:#fff; color:var(--ink); outline:none; transition:.2s border, .2s box-shadow;
        }
        textarea{min-height:120px; resize:vertical}
        input:focus, select:focus, textarea:focus{ border-color:var(--brand-2); box-shadow:0 0 0 4px var(--ring) }
        .help{color:var(--muted); font-size:13px; margin-top:6px}

        .file{display:flex; align-items:center; gap:12px; border:1px dashed #cfe3dc; background:#f4fbf9; padding:14px; border-radius:12px}
        .file input{display:none}
        .file .btn{display:inline-block; padding:10px 14px; background:var(--brand); color:#fff; border-radius:10px; cursor:pointer; font-weight:600}
        .file .name{font-size:14px; color:var(--muted)}

        .row{display:flex; align-items:center; gap:10px}
        .consent{display:flex; gap:10px; align-items:flex-start; font-size:14px; color:var(--muted)}

        .actions{display:flex; gap:12px; justify-content:flex-end; padding:4px 0 8px}
        .btn{appearance:none; border:0; border-radius:12px; padding:12px 18px; font-weight:700; cursor:pointer}
        .btn.secondary{background:#eef4f4; color:#0b3b36}
        .btn.primary{background:var(--brand); color:#fff}
        .btn.primary:hover{background:#0f5a52}
        .note{font-size:12px; color:var(--muted); text-align:center; padding:4px 0 22px}      
      `}</style>
      <div class="wrap">
        <div class="card" role="region" aria-labelledby="formTitle">
          <div class="head">
            <h1 id="formTitle" class="title">Apply</h1>
          </div>
          <div class="brandbar" aria-hidden="true"></div>

          <form onSubmit={handleSubmit} onReset={handleReset} action="#" method="post" enctype="multipart/form-data" novalidate>
            <div class="grid">
              <div>
                <label for="fullName">Full Name<span class="req" aria-hidden="true">*</span></label>
                <input id="fullName" name="fullName" type="text" autocomplete="name" required placeholder="e.g., Mohammed Hashem" value={form.fullName} onChange={onChange} />
              </div>
              <div>
                <label for="email">Email<span class="req" aria-hidden="true">*</span></label>
                <input id="email" name="email" type="email" autocomplete="email" required placeholder="name@example.com"  value={form.email} onChange={onChange}/>
              </div>
              <div>
                <label for="phone">Phone<span class="req" aria-hidden="true">*</span></label>
                <input id="phone" name="phone" type="tel" inputmode="tel" required placeholder="e.g., +966 5X XXX XXXX" value={form.phone} onChange={onChange} />
                <p class="help">Include country code.</p>
              </div>
              <div>
                <label for="role">Position Applying For<span class="req" aria-hidden="true">*</span></label>
                <select id="role" name="role" required value={form.role} onChange={onChange}>
                  <option value="" disabled selected>Select a role…</option>
                  <option>System & Network Support Engineer</option>
                  <option>IT Administrator</option>
                  <option>IT Security Analyst</option>
                  <option>SAP Functional Consultant</option>
                  <option>Procurement Specialist</option>
                  <option>Sales Specialist</option>
                  <option>Accountant</option>
                  <option>Mechanical Engineer</option>
                  <option>Electrical Engineer</option>
                  <option>Marketing Specialist</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label for="department">Department</label>
                <select id="department" name="department" value={form.department} onChange={onChange}>
                  <option value="" disabled selected>Select a department…</option>
                  <option>Information Technology</option>
                  <option>Operations</option>
                  <option>Finance</option>
                  <option>Supply Chain</option>
                  <option>Sales & BD</option>
                </select>
              </div>
              <div>
                <label for="startDate">Earliest Start Date</label>
                <input id="startDate" name="startDate" type="date" value={form.startDate} onChange={onChange}/>
              </div>
            </div>

            <div class="grid">
              <div>
                <label for="linkedin">LinkedIn Profile</label>
                <input id="linkedin" name="linkedin" type="url" placeholder="https://www.linkedin.com/in/…" value={form.linkedin} onChange={onChange}/>
              </div>
              <div>
                <label for="salary">Expected Salary (SAR)</label>
                <input id="salary" name="salary" type="number" min="0" step="500" placeholder="e.g., 5000" value={form.salary} onChange={onChange} />
              </div>
            </div>

            <div>
              <label>Resume / CV (PDF, DOCX)<span class="req" aria-hidden="true">*</span></label>
              <div class="file">
                <label for="cvUpload" class="btn">Choose file</label>
                <input id="cvUpload" name="cv" type="file" accept=".pdf,.doc,.docx,.rtf" required onChange={onCvChange}/>
                <span id="fileName" class="name">{fileName}</span>
              </div>
              <p class="help">Max 5MB. Include certifications or portfolio links in your resume.</p>
            </div>

            <div>
              <label for="cover">Cover Letter</label>
              <textarea id="cover" name="cover" placeholder="Briefly tell us why you'd be a great fit at DMCO…" value={form.cover} onChange={onChange}></textarea>
            </div>

            <div class="consent">
              <input id="consent" name="consent" type="checkbox" required checked={form.consent} onChange={onChange}/>
              <label for="consent">I consent to DMCO processing my application and storing my information for recruitment purposes.</label>
            </div>

            <div class="actions">
              <button class="btn secondary" type="reset" disabled={submitting}>Clear</button>
              {/* <button class="btn primary" type="submit" disabled={submitting}> */}
              <button class="btn primary" type="submit" disabled={status==='submitting'}>
                {/* {submitting ? 'Submitting…' : 'Submit Application'} */}
                {status === 'submitting' ? 'Submitting…' : 'Submit Application'}
              </button>
            </div>
            <p class="note">Protected by best-practice data handling. We never share your information without consent.</p>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ApplicationForm